var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34,
    clipPath: "url(#clip0_5089_242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6589 0H3.34115C2.45483 0.000537751 1.605 0.352962 0.978476 0.9798C0.351948 1.60664 -1.63171e-07 2.45658 0 3.3428L0 14.6572C-1.63171e-07 15.5434 0.351948 16.3934 0.978476 17.0202C1.605 17.647 2.45483 17.9995 3.34115 18H14.6589C15.0978 18 15.5324 17.9135 15.9379 17.7455C16.3434 17.5775 16.7118 17.3312 17.0221 17.0208C17.3324 16.7104 17.5785 16.3418 17.7463 15.9363C17.914 15.5307 18.0003 15.0961 18 14.6572V3.3428C18.0003 2.90391 17.914 2.46927 17.7463 2.06372C17.5785 1.65816 17.3324 1.28964 17.0221 0.979206C16.7118 0.668772 16.3434 0.422511 15.9379 0.254495C15.5324 0.0864787 15.0978 -8.08975e-08 14.6589 0ZM9.00101 13.0649H3.96191V11.4422H9.00101V13.0649ZM13.8981 9.73631H3.96799V8.11359H13.9083L13.8981 9.73631ZM13.9103 6.32657H3.98219V4.70385H13.9103V6.32657Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5089_242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.b4f09168f5bd0ab5609d1236fa5bf03b.svg";
export { ForwardRef as ReactComponent };